import React, {FC, useEffect,useRef} from "react";
import {Accordion} from "react-bootstrap";
import QuicktipLobbyWidget from "./QuicktipLobbyWidget";
import QuickbetXLobbyWidget from "./QuickbetXLobbyWidget";
import JackpotLobbyWidget from "./JackpotLobbyWidget";
import SmartbetLobbyWidget from "./SmartbetLobbyWidget";
import QuickbetLobbyWidget from "./QuickbetLobbyWidget";
import SuperbetLobbyWidget from "./SuperbetLobbyWidget";
import './SidebarLobbyWidget.css';

interface SidebarLobbyWidget {
    atagParams: string | null,
    types?: number[] | null,
    theme?: string | null
    sourceParams: string | null,
    viewType: string | null,
    ticketOpenMode: string | null,
}

const SidebarLobbyWidget: FC  <SidebarLobbyWidget>  = ({atagParams, types, theme, ticketOpenMode, viewType, sourceParams}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (viewType === 'sidebar') {
            const sendHeight = () => {
                const height = document.body.scrollHeight;

                window.parent.postMessage(
                    {
                        type: "SET_LOBBY_SIDEBAR_WIDGET_HEIGHT",
                        height
                    },
                    "*"
                );
            };

            sendHeight();
            const observer = new ResizeObserver(() => {
                sendHeight();
            });

            observer.observe(document.body);

            return () => {
                observer.disconnect();
            };
        }
    }, [viewType]);
    useEffect(() => {
        if (ticketOpenMode !== "modal") return;

        const handleClickCapture = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const link = target.closest("a");
            if (!link) return;

            if (!link.classList.contains("sidebar-ticket-link")) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            window.parent.postMessage(
                {
                    type: "OPEN_SIDEBAR_TICKET_MODAL",
                    url: (link as HTMLAnchorElement).href,
                    widgetId: 'lobbySidebarModalID'
                },
                "*"
            );
        };
        document.addEventListener("click", handleClickCapture, true);

        return () => {
            document.removeEventListener("click", handleClickCapture, true);
        };
    }, [ticketOpenMode]);
    return (
        <div className="Sidebar-widget" data-theme={theme}>
            <div className="betting-tips-card" ref={containerRef}>
                <div className="betting-tips-header">
                    <p className="betting-tips-title">Betting Tips</p>
                </div>

                <hr className="betting-tips-divider"/>

                <Accordion
                    defaultActiveKey="0"
                    flush
                    className="betting-tips-accordion"
                >
                    <SmartbetLobbyWidget
                        atagParams={atagParams}
                        sourceParams={sourceParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                    />
                    <QuicktipLobbyWidget
                        atagParams={atagParams}
                        sourceParams={sourceParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                    />
                    <JackpotLobbyWidget
                        atagParams={atagParams}
                        sourceParams={sourceParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                    />
                    <QuickbetXLobbyWidget
                        atagParams={atagParams}
                        sourceParams={sourceParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                    />
                    <SuperbetLobbyWidget
                        atagParams={atagParams}
                        sourceParams={sourceParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                    />
                    <QuickbetLobbyWidget
                        atagParams={atagParams}
                        sourceParams={sourceParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                    />
                </Accordion>
            </div>
        </div>
    );
};

export default SidebarLobbyWidget;
